import React, {useState, useEffect, useRef, useMemo, ReactHTMLElement, HTMLAttributes} from 'react'
import {Image, Space, PreviewGroup, Modal, Message, Tooltip} from '@bedrock/components'
import {Copy} from '@bedrock/icons-react'
import copy from "copy-to-clipboard";
import { localPx2rem } from '#utils';


type CopyIconProps = {
    text: string;
    tipToolTitle?: string;
} & Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>
export default function CopyIcon(props: CopyIconProps) {
    const { text, tipToolTitle, style, ...restprops } = props;
    const handleCopy = (v) => {
        copy(v)
        Message.success({ content: '复制成功' });
    }
    const icon = <Copy
        {...restprops}
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            margin: `0 ${localPx2rem(4)}`,
            cursor: 'pointer',
            color: 'var(--text-color-2)',
            verticalAlign: 'baseline',
            ...style
        }}
        onClick={(e) => {
            e.stopPropagation()
            handleCopy(text)
         }}
    />

    if (!text) {
        return null
    }

    if (tipToolTitle) {
        return <Tooltip title={tipToolTitle}>
            {icon}
        </Tooltip>
    } else {
        return icon
    }
}
